import Route from '@ember/routing/route';
import useSellerOnly from 'sh-www/mixins/seller-only-route-mixin';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

class SettingsPayoutRoute extends Route.extend(useSellerOnly) {
  /** @inheritDoc */
  get queryParams() {
    return {
      payoneerRedirect: {},
    }
  }

  /** @inheritDoc */
  model({ payoneerRedirect }) {
    /**
     * When being redirected from Payoneer, sync PayoutAccounts to ensure we have the latest data
     * before displaying anything to the user.
     */
    return {
      syncPayoutAccountsOnInit: payoneerRedirect === 'true',
      user: null,
    };
  }

  /** @inheritDoc */
  activate(transition) {
    super.activate(...arguments);

    this.controllerFor('settings').set('newSettingsPage', true);
    trackPageViewFromTransition(this, transition, '/settings/payout/');
  }

  /** @inheritDoc */
  deactivate() {
    super.deactivate(...arguments);

    this.controllerFor('settings').set('newSettingsPage', false);
  }

  /** @inheritDoc */
  setupController(controller, model) {
    super.setupController(...arguments);

    controller.loadUser.perform(model.syncPayoutAccountsOnInit);
  }

  /** @inheritDoc */
  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.set('payoneerRedirect', null);
      controller.loadUser.cancelAll();
    }
  }
}

export default SettingsPayoutRoute;
